import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { Dropdown, Menu } from 'antd'
import MemberAvatarView from '../../elements/Members/MemberAvatarView'

class AccountDropdown extends Component {
  render() {
    const { actions, float, member, color, operations } = this.props
    const menu = (
      <Fragment>
        <Menu onClick={operations}>
          {actions.map((a) => (
            <Menu.Item key={a.key}>{a.value}</Menu.Item>
          ))}
          {actions.length > 0 && <Menu.Divider />}
          <Menu.Item key={'account'}>
            <a href="#/account">Account</a>
          </Menu.Item>
          <Menu.Divider />
          <Menu.Item key="logout">
            <a>Logout</a>
          </Menu.Item>
        </Menu>
      </Fragment>
    )
    return (
      <Dropdown overlay={menu}>
        <div style={{ marginRight: 20, float: float, cursor: 'pointer' }}>
          <MemberAvatarView id={member.image} />
          <span data-testid="nickname" style={{ marginLeft: 20, fontSize: 20, fontWeight: 'bold', color }}>
            {member.nickname}
          </span>
        </div>
      </Dropdown>
    )
  }
}

AccountDropdown.propTypes = { actions: PropTypes.array }
AccountDropdown.defaultProps = { actions: [], float: 'left', color: '#1890ff' }

export default AccountDropdown
